
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'
import MuiFormSelect from 'frame/components/mui-form-select'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)

  const hasValues = (list) => Array.isArray(list) && list.length > 0
  const { costCentres, fleetControllers, fleetIds } = filters

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasValues(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={[{ label: 'No cost centre', value: '-' }, ...costCentres]}
            value={filtered.costCentre}
            includeEmptyOption
            emptyOptionLabel="All cost centres"
            onChange={onSelect('costCentre')} />
        )}
        {hasValues(fleetControllers) && (
          <MuiFormSelect
            id="fleetController"
            label="Fleet Controller"
            options={fleetControllers}
            value={filtered.fleetController}
            onChange={onSelect('fleetController')}
            includeEmptyOption />
        )}
        {hasValues(fleetIds) && (
          <MuiFormSelect
            id="fleetId"
            label="Fleet"
            options={fleetIds}
            value={filtered.fleetId}
            onChange={onSelect('fleetId')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
